// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"429":"8ef3f5d8","661":"8ef3f5d8"}[chunkId] + ".chunk.css";
};